export const textual_content_tech_info = {
  KORORAA_textual_content: {
    ok: true,
    content: [
      {
        index: "tech_info.md",
        content_type: "Markdown",
        text: "## NSHM Technical Information",
        created: "2024-02-13T00:00:00",
        author: "Chris DiCaprio",
        tags: ["help"],
        status: "Draft",
      },
    ],
  },
};

export const textual_content_science_reports = {
  science_reports: {
    ok: true,
    reports: [
      {
        filename: "SR2022-57 NSHM Summary Report_FINAL.pdf",
        title: "New Zealand National Seismic Hazard Model 2022 Revision: model, hazard and process overview",
        status: "Published",
        notes: null,
        report_number: "SR 2022/57",
        lead_author: { name: "Matt Gerstenberger" },
        publication_date: null,
        bibliographic_ref: "et al",
      },
    ],
  },
};
